import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterDropdown_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterArticle_template} from "./filterArticle_template";

declare var ko: any;

export class config_ai_template extends vnTemplate {

    protected contentTypesForQuiz: multipleSelector_template;
    protected articleTypesForQuiz: multipleSelector_template;
    protected contentTypesForSummary: multipleSelector_template;
    protected articleTypesForSummary: multipleSelector_template;
    protected contentTypesForFaq: multipleSelector_template;
    protected articleTypesForFaq: multipleSelector_template;
    public filterArticle: filterArticle_template;
    protected initialValues ;

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

 protected getTemplateHtml(): string {
    return /*html*/`
    <div class="w-form w-form-large w-ai-config">
        <div class="form-header">
            <h3 class="form-title icon i-ai">Assistant Config</h3>
        </div>

        <div class="form-pagination only-text">
            <button type="button" data-bind="click: () => activeTab('general'), visible: permissions()['config_assistant_general'] && permissions()['config_assistant_general'].write , css: { active: activeTab() === 'general' }">General</button>
            <button type="button" data-bind="click: () => activeTab('website'), visible: permissions()['config_assistant_website'] && permissions()['config_assistant_website'].write , css: { active: activeTab() === 'website' }">Website</button>
            <button type="button" data-bind="click: () => activeTab('emaki'), visible:  permissions()['config_assistant_emaki'] && permissions()['config_assistant_emaki'].write , css: { active: activeTab() === 'emaki' }">Emaki</button>
        </div>

        <!-- General Tab -->
        <div class="ww-form-body" data-bind="visible: activeTab() === 'general' && permissions()['config_assistant_general'] && permissions()['config_assistant_general'].write">
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title parent">Brand Context</strong>

                    <div class="form-group">
                        <label for="brandContext" class="form-label">Website Assistant Brand Context</label>
                        <textarea class="input-text" data-bind="value: brandContext" id="brandContext" style="height:20rem;" maxlength="2000"></textarea>
                    </div>
                    <div class="form-group">
                        <label for="emakiBrandContext" class="form-label">Emaki Assistant Brand Context</label>
                        <textarea class="input-text" data-bind="value: emakiBrandContext" id="emakiBrandContext" style="height:20rem;" maxlength="2000"></textarea>
                    </div>
                </div>
                <div class="form-body">
                    <strong class="form-sub-title parent">Personalities</strong>
                    <div class="form-group">
                        <label for="factualSummaryPersonality" class="form-label">Factual Personality</label>
                        <textarea class="input-text" data-bind="value: factualSummaryPersonality" id="factualSummaryPersonality" style="height:20rem;"  maxlength="2000" ></textarea>
                    </div>
                    <div class="form-group">
                        <label for="satiricalSummaryPersonality" class="form-label">LightHearted Personality</label>
                        <textarea class="input-text" data-bind="value: satiricalSummaryPersonality" id="satiricalSummaryPersonality" style="height:20rem;"  maxlength="2000" ></textarea>
                    </div>
                    <div class="form-group">
                        <label for="simpleSummaryPersonality" class="form-label">Simple Personality</label>
                        <textarea class="input-text" data-bind="value: simpleSummaryPersonality" id="simpleSummaryPersonality" style="height:20rem;"  maxlength="2000"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <!-- Website Tab -->
        <div class="ww-form-body" data-bind="visible: activeTab() === 'website' && permissions()['config_assistant_website'] && permissions()['config_assistant_website'].write">
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title parent">Article Summaries</strong>
                    <div class="form-group row">
                        <div>
                            <input type="checkbox" data-bind="checked: factualSummaryAvailable" class="input-checkbox" id="factualSummaryAvailable">
                            <label class="form-label icon i-check" for="factualSummaryAvailable">Enable Factual Summary</label>
                        </div>
                        <div >
                            <input type="checkbox" data-bind="checked: satiricalSummaryAvailable" class="input-checkbox" id="satiricalSummaryAvailable">
                            <label class="form-label icon i-check" for="satiricalSummaryAvailable">Enable LightHearted Summary</label>
                        </div>
                        <div>
                            <input type="checkbox" data-bind="checked: simpleSummaryAvailable" class="input-checkbox" id="simpleSummaryAvailable">
                            <label class="form-label icon i-check" for="simpleSummaryAvailable">Enable Simple Summary</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <hr class="form-hr">
                    </div>
                    <div style="display: flex;">
                        <div class="form-group">
                            <legend class="form-legend">Content Types</legend>
                            ${this.contentTypesForSummary.getHtmlBuild()}
                        </div>
                        <div class="form-group">
                            <legend class="form-legend">Article Types</legend>
                            ${this.articleTypesForSummary.getHtmlBuild()}
                        </div>
                    </div>
                     <div class="form-group">
                        <hr class="form-hr">
                    </div>

                    <div class="form-group">
                        <label for="summaryPrompt" class="form-label">Prompt</label>
                        <textarea class="input-text" data-bind="value: summaryPrompt" id="summaryPrompt" style="height: 20rem;"></textarea>
                    </div>
                </div>
                <div class="form-body">


                    <strong class="form-sub-title parent">Article Quizzes</strong>
                    <!-- same quiz form content here as original, unchanged -->
                </div>
                <!-- FAQ SECTION: COMMENTED OUT ON PURPOSE DON'T DELETE 
                <div class="form-body">

                    <strong class="form-sub-title parent">Article FAQ</strong>
                    <div class="form-group">
                        <div class="form-check-inline" style="width: auto;">
                            <input type="checkbox" data-bind="checked: faqAvailable" class="input-checkbox" id="faqAvailable">
                            <label class="form-label icon i-check" for="faqAvailable">Available For Use</label>
                        </div>                    
                    </div>                    
                    <div class="d-flex">
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Content Types</legend>
                                ${this.contentTypesForFaq.getHtmlBuild()}
                                <div style="display: none;" id="selected_faqContentTypes" class="filters-selected"></div>
                            </div>
                            <div class="form-group" data-bind="foreach: selectedfaqContentTypes">
                                <div class="btn-selection">
                                    <span data-bind="text: name"></span>
                                    <button data-bind="event: {click: $parent.onClickDeleteSelectedContentTypeFAQ}, disable: $parent.isNotDeletable()" class="icon i-x-after" type="button"></button>
                                </div>
                            </div>
                        </div>
                        <div style="width: 50%;">
                            <div class="form-group">
                                <legend class="form-legend">Article Types</legend>
                                ${this.articleTypesForFaq.getHtmlBuild()}
                                <div style="display: none;" id="selected_articleTypes" class="filters-selected"></div>
                            </div>
                            <div class="form-group" data-bind="foreach: selectedfaqArticleTypes">
                                <div class="btn-selection">
                                    <span data-bind="text: name"></span>
                                    <button data-bind="event: {click: $parent.onClickDeleteSelectedArticleTypeFAQ}, disable: $parent.isNotDeletable()" class="icon i-x-after" type="button"></button>
                                </div>
                            </div>      
                        </div>      
                    </div>  

                    <div class="form-group">
                        <label for="faqPersonality" class="form-label">Personality</label>
                        <select class="input-select" data-bind="value: faqPersonality" id="faqPersonality">
                            <option value="">Select a Personality</option>
                            <option value="simple">Simple</option>
                            <option value="factual">Factual</option>
                            <option value="satirical">Satirical</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="faqPrompt" class="form-label">Prompt <span style="color:red">*</span></label>
                        <textarea class="input-text" data-bind="value: faqPrompt" id="faqPrompt" style="height: 20rem;" required></textarea>
                    </div>                    
                </div> -->
            </div>
        </div>

        <!-- Emaki Tab -->
        <div class="ww-form-body" data-bind="visible: activeTab() === 'emaki' &&   permissions()['config_assistant_emaki'] && permissions()['config_assistant_emaki'].write">

                <div class="w-form-body" style=" width: 100%;">


                </div>

                <div class="w-form-body textarea" style=" width: 100%;">

                    <div class="form-body">

                        <div class="form-group inside-label">
                            <label class="form-label" for="idArticle" > Test Article For Config Assistant </label>
                            ${this.filterArticle.getHtmlBuild()}
                        </div>

                        <strong class="form-sub-title parent">Article-Level Prompts</strong>




                        <div class="form-group row">

                            <div class="w-textarea">
                                <!-- <label for="titleDiscoverandOptimizePrompt" class="form-label">Title Prompt</label> -->
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: titleDiscoverandOptimizePromptAvailable" class="input-checkbox" id="titleDiscoverandOptimizePromptAvailable">
                                    <label class="form-label icon i-check" for="titleDiscoverandOptimizePromptAvailable">Enable Title Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: titleDiscoverandOptimizePrompt, disable: !titleDiscoverandOptimizePromptAvailable()" id="titleDiscoverandOptimizePrompt"  maxlength="2000" ></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form icon i-ai-1 e-lab" title="Test Prompt"  id="title-analysis-button" data-bind="click: function() { onClickAnalyzeTitle('both')} , disable: isAiAnalyzing() || !titleDiscoverandOptimizePromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetTitleDiscoverandOptimizePrompt ,disable: !titleDiscoverandOptimizePromptAvailable()" type="button"></button>
                            </div>

                        </div>

                        <div class="form-group row">
                            <!-- <label for="excerptSuggestionPrompt" class="form-label">Excerpt Prompt</label> -->
                            <div class="w-textarea">
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: excerptSuggestionPromptAvailable" class="input-checkbox" id="excerptSuggestionPromptAvailable">
                                    <label class="form-label icon i-check" for="excerptSuggestionPromptAvailable">Enable Excerpt Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: excerptSuggestionPrompt,disable: !excerptSuggestionPromptAvailable()" id="excerptSuggestionPrompt"  maxlength="2000"></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form light icon i-ai-1 e-lab" title="Test Prompt"  id="title-analysis-button" data-bind="click: function() { onClickAnalyzeExcerpt()} , disable: isAiAnalyzing() || !excerptSuggestionPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetExcerptSuggestionPrompt, disable: !excerptSuggestionPromptAvailable()"></button>
                            </div>
                        </div>


                         <div class="form-group row">
                            <!-- <label for="seoSuggestionPrompt" class="form-label">SEO Fields (SEO Title & SEO Description) Prompt</label> -->
                            <div class="w-textarea">
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: seoSuggestionPromptAvailable" class="input-checkbox" id="seoSuggestionPromptAvailable">
                                    <label class="form-label icon i-check" for="seoSuggestionPromptAvailable">Enable SEO Fields (SEO Title & SEO Description) Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: seoSuggestionPrompt,disable: !seoSuggestionPromptAvailable()" id="seoSuggestionPrompt"  maxlength="2000"></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form light icon i-ai-1 e-lab" title="Test Prompt"  id="title-analysis-button" data-bind="click: function() { onClickAnalyzeSeo()} , disable: isAiAnalyzing() || !seoSuggestionPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetSeoSuggestionPrompt, disable: !seoSuggestionPromptAvailable()"></button>
                            </div>
                        </div>

                        <div class="form-group row">
                            <!-- <label for="socialmediaSuggestionPrompt" class="form-label">Social Media Fields (SMO Title, SMO Description, & Social Tagline) Prompt</label> -->
                            <div class="w-textarea">
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: socialmediaSuggestionPromptAvailable" class="input-checkbox" id="socialmediaSuggestionPromptAvailable">
                                    <label class="form-label icon i-check" for="socialmediaSuggestionPromptAvailable">Enable Social Media Fields (SMO Title, SMO Description, & Social Tagline) Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: socialmediaSuggestionPrompt ,disable: !socialmediaSuggestionPromptAvailable()" id="socialmediaSuggestionPrompt"  maxlength="2000"></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form light icon i-ai-1 e-lab" title="Test Prompt"  id="title-analysis-button" data-bind="click: function() { onClickAnalyzeSocialMedia()} , disable: isAiAnalyzing() || !socialmediaSuggestionPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetSocialmediaSuggestionPrompt,disable: !socialmediaSuggestionPromptAvailable()"></button>
                            </div>
                        </div>

                        <div class="form-group row">
                            <!-- <label for="threadSuggestionPrompt" class="form-label">Thread Fields (Thread Prompt & Thread Prompt Response) Prompt/label> -->
                            <div class="w-textarea">
                                <div class="form-check-inline">
                                    <input type="checkbox" data-bind="checked: threadSuggestionPromptAvailable" class="input-checkbox" id="threadSuggestionPromptAvailable">
                                    <label class="form-label icon i-check" title="refresh" for="threadSuggestionPromptAvailable">Enable Thread Fields (Thread Prompt & Thread Prompt Response) Prompt</label>
                                </div>
                                <textarea class="input-text" data-bind="value: threadSuggestionPrompt,disable: !threadSuggestionPromptAvailable()" id="threadSuggestionPrompt"  maxlength="2000" ></textarea>
                            </div>
                            <div class="w-btn-vert">
                                <button class="btn-form light icon i-ai-1 e-lab" title="Test Prompt"  id="title-analysis-button" data-bind="click: function() { onClickAnalyzeThread()} , disable: isAiAnalyzing() || !threadSuggestionPromptAvailable()"  type="button"></button>
                                <button class="btn-form icon i-refresh" title="Reset Prompt" data-bind="click: resetThreadSuggestionPrompt,disable: !threadSuggestionPromptAvailable()"></button>
                            </div>
                        </div>

                </div>

                <div class="w-form w-form-side ">

                    <div class="form-side-header-assistant">
                        <button id="btn-sidebar-hide" class="btn-sidebar hide icon i-dropdown-simple-b" type="button" data-bind="click: onClickToggleAssistant"></button>
                        <strong class="side-title icon i-ai-1">Assistant</strong>
                        <button id="btn-sidebar-expend" class="btn-sidebar expend icon i-expend" type="button" data-bind="click: onClickToggleAssistantExpand" ></button>
                        <!-- <button class="icon i-settings" type="button"></button> -->
                    </div>
                    <div class="form-body full-width cover w-title-analysis is-visible" id="title-analysis-window">
                        <div class="form-group w-chat-suggestions" data-bind="" id="title-analysis-content">

                        </div>
                    </div>
                </div>

            </div>

        </div>



        <div class="form-footer">
            <button data-bind="event: {click: onClickCancelAiSettings}" class="btn" type="button">Cancel</button>
            <button data-bind="event: {click: onClickSaveAiSettings}" class="btn highlight" type="button">Save</button>
        </div>
    </div>

    `;


}



    protected buildViewModel(): any {
        let self = this;
        let viewModel =  {
            simpleSummaryPersonality: ko.observable(""),
            factualSummaryPersonality: ko.observable(""),
            satiricalSummaryPersonality: ko.observable(""),
            brandContext: ko.observable(""),
            emakiBrandContext: ko.observable(""),
            summaryPrompt: ko.observable(""),
            articleID: ko.observable(""),
            quizAvailable: ko.observable(true),
            summaryAvailable: ko.observable(true),
            factualSummaryAvailable: ko.observable(true),
            satiricalSummaryAvailable: ko.observable(true),
            simpleSummaryAvailable: ko.observable(true),
            quizPrompt: ko.observable(""),
            quizBrandContext: ko.observable(true),
            quizPersonality: ko.observable(""),
            titleDiscoverandOptimizePrompt: ko.observable(""),
            seoSuggestionPromptAvailable: ko.observable(false),
            seoSuggestionPrompt: ko.observable(""),
            socialmediaSuggestionPromptAvailable: ko.observable(false),
            socialmediaSuggestionPrompt: ko.observable(""),
            threadSuggestionPromptAvailable: ko.observable(false),
            threadSuggestionPrompt: ko.observable(""),
            excerptSuggestionPromptAvailable: ko.observable(false),
            titleDiscoverandOptimizePromptAvailable: ko.observable(false),
            excerptSuggestionPrompt: ko.observable(""),
            selectedContentTypes: ko.observableArray([]),
            selectedArticleTypes: ko.observableArray([]),
            selectedContentTypesSummary: ko.observableArray([]),
            selectedArticleTypesSummary: ko.observableArray([]),
            faqAvailable: ko.observable(false),
            faqPersonality: ko.observable(""),
            selectedfaqContentTypes: ko.observableArray([]),
            selectedfaqArticleTypes: ko.observableArray([]),
            faqPrompt: ko.observable(""),
            permissions: ko.observableArray(['config_assistant', 'config_assistant_general','config_assistant_website','config_assistant_emaki' ]),
            activeTab: ko.observable('general'),
            isAiAnalyzing: ko.observable(false),
            resetExcerptSuggestionPrompt: function (event) {
                self.resetExcerptSuggestionPrompt();
            },
            resetSeoSuggestionPrompt: function(event) {
                self.resetSeoSuggestionPrompt();
            },
            resetSocialmediaSuggestionPrompt: function(event) {
                self.resetSocialmediaSuggestionPrompt();
            },
            resetThreadSuggestionPrompt: function(event) {
                self.resetThreadSuggestionPrompt();
            },
            resetTitleDiscoverandOptimizePrompt: function(event) {
                self.resetTitleDiscoverandOptimizePrompt();
            },
            onClickAnalyzeTitle: function (data, event) {
                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeTitle(data);

                const settingsEl = document.getElementById("title-analysis-settings");
                if (!settingsEl) return;

                if (settingsEl.classList.contains("is-visible")) {
                    settingsEl.classList.remove("is-visible");

                     const settingsB = document.getElementById("title-analysis-settings-button");
                    if (!settingsB) return;
                    if (!settingsB.classList.contains("i-settings")) {
                        settingsB.classList.add("i-settings");
                    }
                    settingsB.classList.remove("i-recat-log");
                }




            },

            onClickAnalyzeSeo: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeSeo();



            },
            onClickAnalyzeSocialMedia: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeSocialMedia();

            },
            onClickAnalyzeThread: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeThread();

            },


            onClickAnalyzeExcerpt: function (data, event) {

                document.getElementById("title-analysis-window").classList.add("is-visible");
                document.getElementById("title-analysis-window").classList.remove("is-collapsed");
                this.isAiAnalyzing(true);
                self.onClickAnalyzeExcerpt();



            },
            onClickCancelAiSettings: function (data, event) {
                self.onClickCancelAiSettings();
            },
            onClickSaveAiSettings: function (data, param, event) {
                self.onClickSaveAiSettings();
            },
            onClickDeleteSelectedContentType: function (data) {
                self.onClickDeleteSelectedContentType(data);
            },
            onClickDeleteSelectedArticleType: function (data) {
                self.onClickDeleteSelectedArticleType(data);
            },
            onClickDeleteSelectedContentTypeSummary: function (data) {
                self.onClickDeleteSelectedContentTypeSummary(data);
            },
            onClickDeleteSelectedArticleTypeSummary: function (data) {
                self.onClickDeleteSelectedArticleTypeSummary(data);
            },
            onClickDeleteSelectedContentTypeFAQ: function (data) {
                self.onClickDeleteSelectedContentTypeFAQ(data);  
            },
            onClickDeleteSelectedArticleTypeFAQ:function (data){
                self.onClickDeleteSelectedArticleTypeFAQ(data);
            },
            isNotDeletable: function () {
                return false;
            },
            onClickToggleAssistant: function (data, event) {
                const wFormArticle = document.querySelector(".w-form-article");
                if (wFormArticle.classList.contains("is-sidebar-closed")) {
                    wFormArticle.classList.remove("is-sidebar-closed");
                } else {
                    wFormArticle.classList.remove("is-sidebar-expanded");
                    wFormArticle.classList.add("is-sidebar-closed");
                }
            },
            onClickToggleAssistantExpand: function (data, event) {
                const wFormArticle = document.querySelector(".w-form-article");
                if (wFormArticle.classList.contains("is-sidebar-expanded")) {
                    wFormArticle.classList.remove("is-sidebar-expanded");
                } else {
                    wFormArticle.classList.add("is-sidebar-expanded");
                }
            },

        };
          ko.computed(function () {
                if (!viewModel.factualSummaryAvailable() &&
                    !viewModel.satiricalSummaryAvailable() &&
                    !viewModel.simpleSummaryAvailable()) {
                    viewModel.summaryAvailable(false);
                }else {
                    viewModel.summaryAvailable(true);
                }

        });

                return viewModel;

    }

    protected initPartial(): void {
        this.contentTypesForQuiz = new multipleSelector_template("configai_contentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypesForQuiz.setFilterContainerClass('margin-neg');
        this.contentTypesForQuiz.setSelectAllEnabled(true);
        this.contentTypesForQuiz.setSearchEnabled(true);
        this.contentTypesForQuiz.setTagContainerId('selected_contentTypes');
        this.contentTypesForQuiz.setLabel("Content Types");

        this.articleTypesForQuiz = new multipleSelector_template("configai_articleTypeFilter", this.getTemplateViewModel(), this.caller);
        this.articleTypesForQuiz.setFilterContainerClass('margin-neg');
        this.articleTypesForQuiz.setSelectAllEnabled(true);
        this.articleTypesForQuiz.setSearchEnabled(true);
        this.articleTypesForQuiz.setTagContainerId('selected_articleTypes');
        this.articleTypesForQuiz.setLabel("Article Types");

        this.contentTypesForSummary = new multipleSelector_template("configai_contentTypeFilterSummary", this.getTemplateViewModel(), this.caller);
        this.contentTypesForSummary.setFilterContainerClass('margin-neg');
        this.contentTypesForSummary.setSelectAllEnabled(true);
        this.contentTypesForSummary.setSearchEnabled(true);
        this.contentTypesForSummary.setTagContainerId('selected_contentTypes_summary');
        this.contentTypesForSummary.setLabel("Content Types");

        this.contentTypesForFaq = new multipleSelector_template("configai_faqContentTypes", this.getTemplateViewModel(), this.caller);
        this.contentTypesForFaq.setFilterContainerClass('margin-neg');
        this.contentTypesForFaq.setSelectAllEnabled(true);
        this.contentTypesForFaq.setSearchEnabled(true);
        this.contentTypesForFaq.setTagContainerId('selected_faqContentTypes');
        this.contentTypesForFaq.setLabel("FAQ Content Types");

        this.articleTypesForFaq = new multipleSelector_template("configai_articleTypeFilterFaq", this.getTemplateViewModel(), this.caller);
        this.articleTypesForFaq.setFilterContainerClass('margin-neg');
        this.articleTypesForFaq.setSelectAllEnabled(true);
        this.articleTypesForFaq.setSearchEnabled(true);
        this.articleTypesForFaq.setTagContainerId('selected_articleTypes_faq');
        this.articleTypesForFaq.setLabel("FAQ Article Types");
        this.articleTypesForFaq.setItems([
            { id: 2, name: "Regular" },
            { id: 3, name: "List" },
            { id: 9, name: "Buyer's Guide Light" },
            { id: 10, name: "Deals" },
            { id: 12, name: "Collection" },
            { id: 7, name: "Directory" },
            { id: 11, name: "Versus" },
            { id: 13, name: "Sub-Content" },
            { id: 14, name: "How to Watch" },
            { id: 15, name: "Video" },
            { id: 16, name: "Thread" }
        ]); 

        this.articleTypesForSummary = new multipleSelector_template("configai_articleTypeFilterSummary", this.getTemplateViewModel(), this.caller);
        this.articleTypesForSummary.setFilterContainerClass('margin-neg');
        this.articleTypesForSummary.setSelectAllEnabled(true);
        this.articleTypesForSummary.setSearchEnabled(true);
        this.articleTypesForSummary.setTagContainerId('selected_articleTypes_summary');
        this.articleTypesForSummary.setLabel("Article Types");
        // Set static options
        this.articleTypesForQuiz.setItems([
            { id: 2, name: "Regular" },
            { id: 3, name: "List" },
            { id: 9, name: "Buyer's Guide Light" },
            { id: 10, name: "Deals" },
            { id: 12, name: "Collection" },
            { id: 7, name: "Directory" },
            { id: 11, name: "Versus" },
            { id: 13, name: "Sub-Content" },
            { id: 14, name: "How to Watch" },
            { id: 15, name: "Video" },
            { id: 16, name: "Thread" }
        ]);

        this.articleTypesForSummary.setItems([
            { id: 2, name: "Regular" },
            { id: 3, name: "List" },
            { id: 9, name: "Buyer's Guide Light" },
            { id: 10, name: "Deals" },
            { id: 12, name: "Collection" },
            { id: 7, name: "Directory" },
            { id: 11, name: "Versus" },
            { id: 13, name: "Sub-Content" },
            { id: 14, name: "How to Watch" },
            { id: 15, name: "Video" },
            { id: 16, name: "Thread" }
        ]);

        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

    }


    public setArticlesFilter(articles) {

        this.getTemplateViewModel().filterArticle.showDetails(true);
        this.getTemplateViewModel().filterArticle.articles(articles);
    }


    setContentTypeOptions(contentTypes) {
        this.contentTypesForQuiz.setItems(contentTypes);
        this.contentTypesForSummary.setItems(contentTypes);
        this.contentTypesForFaq.setItems(contentTypes);
    }

    onClickAnalyzeTitle(type){

        if(type == 'both'){
           this.addAiUserMessage('Generate title suggestions that are optimized for Google Discover. Also, generate title suggestions that are optimized based on performant similar articles.');

        }else if(type == 'ctr'){
              this.addAiUserMessage('Generate Title Suggestions using ctr Optimization');

        }else if(type == 'optimize'){
             this.addAiUserMessage('Generate Title Suggestions using Discover and Optimize ');

        }
       this.caller.analyzeArticleTitle(type);

    }
    public onClickAnalyzeImage(){
       this.addAiUserMessage('Provide a list of title and image combinations from performant similar articles.');
       this.caller.analyzeArticleByType('image');

    }

     public onClickAnalyzeSeo(){
       this.addAiUserMessage('Draft brief, search-optimized text to help the article stand out in search results.');
       this.caller.analyzeArticleByType('seo');

    }
     public onClickAnalyzeSocialMedia(){
       this.addAiUserMessage(' Create short, attention-grabbing text for sharing the article on social media.');
       this.caller.analyzeArticleByType('socialmedia');

    }
     public onClickAnalyzeThread(){
       this.addAiUserMessage('  Produce Thread discussion prompts and a short response for each.');
       this.caller.analyzeArticleByType('thread');

    }
     public addAiUserMessage(message, type = 'preset') {
            const userMessageEl = document.createElement("div");
            if(type === 'customprompt') {
                    userMessageEl.id = "custom-prompts-content-userMessage";

            }else{
                   userMessageEl.id = "title-analysis-content-userMessage";

            }
            userMessageEl.classList.add("ai-userMessage");
            const messageLength = message.split(/<br>/).reduce((acc, curr) => acc + Math.ceil(curr.length / 40) * 40, 0);

           userMessageEl.innerHTML = `
            <div class="message-body truncated">
                ${message}
            </div>
            ${messageLength > 200 ? `<button class="read-more-btn">Show More</button>` : ''}

            `;

            // Append to container

            const articleSuggestionEl = document.getElementById("title-analysis-content");
            articleSuggestionEl.appendChild(userMessageEl);


            if (messageLength > 200) {
                // Toggle logic
                const messageBody = userMessageEl.querySelector(".message-body");
                const toggleBtn = userMessageEl.querySelector(".read-more-btn");

                toggleBtn.addEventListener("click", () => {
                    const isExpanded = !messageBody.classList.contains("truncated");

                    if (isExpanded) {
                        messageBody.classList.add("truncated");
                        toggleBtn.textContent = "Show More";
                    } else {
                        messageBody.classList.remove("truncated");
                        toggleBtn.textContent = "Hide";
                    }
                });
            }
          this.addAiBotThinking(type);
          this.scrollChatToBottom(false,type);
    }

    public addAiBotThinking(type = 'preset') {

        if(type === 'customprompt') {
            const articleSuggestionEl = document.getElementById("custom-prompts-content");
            const generatingCoverMessageEl = document.createElement("div");
            generatingCoverMessageEl.id = "custom-prompts-content-generating-cover";
            generatingCoverMessageEl.classList.add("ai-thinking");
            generatingCoverMessageEl.innerHTML = `
                                    <div class="loader-dot"></div>
                                `;
            articleSuggestionEl.appendChild(generatingCoverMessageEl);
        }else{
            const articleSuggestionEl = document.getElementById("title-analysis-content");
            const generatingCoverMessageEl = document.createElement("div");
            generatingCoverMessageEl.id = "title-analysis-content-generating-cover";
            generatingCoverMessageEl.classList.add("ai-thinking");
            generatingCoverMessageEl.innerHTML = `
                                        <div class="loader-dot"></div>
                                    `;
            articleSuggestionEl.appendChild(generatingCoverMessageEl);
        }

    }
    public scrollChatToBottom(Tobuttom = false ,type = 'preset') {
        let container;
        if(type === 'customprompt') {
            container = document.getElementById('custom-prompts-content');
        }else{
            container = document.getElementById('title-analysis-content');
        }
        const messages = container.querySelectorAll('.ai-userMessage');
        if(Tobuttom) {
            container.scrollTo({
                top: container.scrollHeight+100,
                behavior: 'smooth'
            });
            return
        }
        if (container && messages && messages.length > 0) {
            const lastMessage = messages[messages.length - 1] as HTMLElement;

            // Remove old spacer if it exists
            const existingSpacer = container.querySelector('.ai-scroll-spacer');
            if (existingSpacer) {
                existingSpacer.remove();
            }

            // Calculate dynamic height
            const containerHeight = container.clientHeight;
            const messageHeight = lastMessage.offsetHeight;
            const dynamicSpacerHeight = Math.max(0, containerHeight - messageHeight);

            // Create new spacer
            const spacer = document.createElement('div');
            spacer.className = 'ai-scroll-spacer';
            spacer.style.height = `${dynamicSpacerHeight}px`;
            spacer.style.opacity = '0';
            spacer.setAttribute('aria-hidden', 'true');

            // Insert spacer after the message
            container.appendChild( spacer);

            // Scroll so the message aligns to the top
            container.scrollTo({
                top: lastMessage.offsetTop,
                behavior: 'smooth'
            });
        }
    }

    public onClickAnalyzeExcerpt(){
       this.addAiUserMessage('Suggest short excerpts to preview the article without giving too much away.');
       this.caller.analyzeArticleByType('excerpt');

    }
    public setSelectedFilterContentTypes(contentTypesId): void {
        let selectedContentTypes = [];
        this.contentTypesForQuiz.getItems().forEach((c) => {
            if (contentTypesId.indexOf(c.id) !== -1) {
                selectedContentTypes.push(c);
            }
        });
        this.getTemplateViewModel().selectedContentTypes(selectedContentTypes);
        this.contentTypesForQuiz.setSelectedItems(selectedContentTypes);
    }

    public updateSelectedContentTypes() {
        let selectedFilterContentTypes = this.contentTypesForQuiz.getSelectedItems();
        let contentTypes = this.contentTypesForQuiz.getItems();

        let contentTypeList = [];
        for (let idContentType of selectedFilterContentTypes) {
            let contentType = contentTypes.find(c => c.id == idContentType);
            if (contentType) {
                contentTypeList.push({
                    id: contentType.id,
                    name: contentType.name
                });
            }
        }

        let selectedContentTypes = this.getTemplateViewModel().selectedContentTypes();

        for (let ct of contentTypeList) {
            let existingContentType = selectedContentTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedContentTypes.push(ct);
            }
        }

        for (let i = selectedContentTypes.length - 1; i >= 0; i--) {
            let contentTypeToRemove = contentTypeList.find(c => c.id == selectedContentTypes[i].id);
            if (!contentTypeToRemove) {
                selectedContentTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedContentTypes([]);
        this.getTemplateViewModel().selectedContentTypes(selectedContentTypes);
    }

    public updateSelectedContentTypesFAQ(){
        let selectedFilterContentTypes = this.contentTypesForFaq.getSelectedItems();
        let contentTypes = this.contentTypesForFaq.getItems();

        let contentTypeList = [];
        for (let idContentType of selectedFilterContentTypes) {
            let contentType = contentTypes.find(c => c.id == idContentType);
            if (contentType) {
                contentTypeList.push({
                    id: contentType.id,
                    name: contentType.name
                });
            }
        }

        let selectedContentTypes = this.getTemplateViewModel().selectedfaqContentTypes();

        for (let ct of contentTypeList) {
            let existingContentType = selectedContentTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedContentTypes.push(ct);
            }
        }

        for (let i = selectedContentTypes.length - 1; i >= 0; i--) {
            let contentTypeToRemove = contentTypeList.find(c => c.id == selectedContentTypes[i].id);
            if (!contentTypeToRemove) {
                selectedContentTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedfaqContentTypes([]);
        this.getTemplateViewModel().selectedfaqContentTypes(selectedContentTypes);
    }

    public updateSelectedArticleTypesFAQ(){

        let selectedFilterArticleTypes = this.articleTypesForFaq.getSelectedItems();
        let articleTypes = this.articleTypesForFaq.getItems();

        let articleTypeList = [];
        for (let idArticleType of selectedFilterArticleTypes) {
            let articleType = articleTypes.find(c => c.id == idArticleType);
            if (articleType) {
                articleTypeList.push(articleType);
            }
        }

        let selectedArticleTypes = this.getTemplateViewModel().selectedfaqArticleTypes();

        for (let ct of articleTypeList) {
            let existingContentType = selectedArticleTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedArticleTypes.push(ct);
            }
        }

        for (let i = selectedArticleTypes.length - 1; i >= 0; i--) {
            let articleTypeToRemove = articleTypeList.find(c => c.id == selectedArticleTypes[i].id);
            if (!articleTypeToRemove) {
                selectedArticleTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedfaqArticleTypes([]);
        this.getTemplateViewModel().selectedfaqArticleTypes(selectedArticleTypes);
    }

    public setSelectedFilterArticleTypes(articleTypesId): void {
        let selectedArticleTypes = [];
        this.articleTypesForQuiz.getItems().forEach((c) => {
            if (articleTypesId.indexOf(c.id) !== -1) {
                selectedArticleTypes.push(c);
            }
        });
        this.getTemplateViewModel().selectedArticleTypes(selectedArticleTypes);
        this.articleTypesForQuiz.setSelectedItems(selectedArticleTypes);
    }

    public updateSelectedArticleTypes() {
        let selectedFilterArticleTypes = this.articleTypesForQuiz.getSelectedItems();
        let articleTypes = this.articleTypesForQuiz.getItems();

        let articleTypeList = [];
        for (let idArticleType of selectedFilterArticleTypes) {
            let articleType = articleTypes.find(c => c.id == idArticleType);
            if (articleType) {
                articleTypeList.push(articleType);
            }
        }

        let selectedArticleTypes = this.getTemplateViewModel().selectedArticleTypes();

        for (let at of articleTypeList) {
            let existingArticleType = selectedArticleTypes.find(c => c.id == at.id);
            if (!existingArticleType) {
                selectedArticleTypes.push(at);
            }
        }

        for (let i = selectedArticleTypes.length - 1; i >= 0; i--) {
            let articleTypeToRemove = articleTypeList.find(c => c.id == selectedArticleTypes[i].id);
            if (!articleTypeToRemove) {
                selectedArticleTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedArticleTypes([]);
        this.getTemplateViewModel().selectedArticleTypes(selectedArticleTypes);
    }

    public setSelectedFilterContentTypesSummary(contentTypesId): void {
        let selectedContentTypes = [];
        this.contentTypesForSummary.getItems().forEach((c) => {
            if (contentTypesId.indexOf(c.id) !== -1) {
                selectedContentTypes.push(c);
            }
        });
        this.getTemplateViewModel().selectedContentTypesSummary(selectedContentTypes);
        this.contentTypesForSummary.setSelectedItems(selectedContentTypes);
    }

    public updateSelectedContentTypesSummary() {
        let selectedFilterContentTypes = this.contentTypesForSummary.getSelectedItems();
        let contentTypes = this.contentTypesForSummary.getItems();

        let contentTypeList = [];
        for (let idContentType of selectedFilterContentTypes) {
            let contentType = contentTypes.find(c => c.id == idContentType);
            if (contentType) {
                contentTypeList.push({
                    id: contentType.id,
                    name: contentType.name
                });
            }
        }

        let selectedContentTypes = this.getTemplateViewModel().selectedContentTypesSummary();

        for (let ct of contentTypeList) {
            let existingContentType = selectedContentTypes.find(c => c.id == ct.id);
            if (!existingContentType) {
                selectedContentTypes.push(ct);
            }
        }

        for (let i = selectedContentTypes.length - 1; i >= 0; i--) {
            let contentTypeToRemove = contentTypeList.find(c => c.id == selectedContentTypes[i].id);
            if (!contentTypeToRemove) {
                selectedContentTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedContentTypesSummary([]);
        this.getTemplateViewModel().selectedContentTypesSummary(selectedContentTypes);
    }

    public setSelectedFilterArticleTypesSummary(articleTypesId): void {
        let selectedArticleTypes = [];
        this.articleTypesForSummary.getItems().forEach((c) => {
            if (articleTypesId.indexOf(c.id) !== -1) {
                selectedArticleTypes.push(c);
            }
        });
        this.getTemplateViewModel().selectedArticleTypesSummary(selectedArticleTypes);
        this.articleTypesForSummary.setSelectedItems(selectedArticleTypes);
    }

    public updateSelectedArticleTypesSummary() {
        let selectedFilterArticleTypes = this.articleTypesForSummary.getSelectedItems();
        let articleTypes = this.articleTypesForSummary.getItems();

        let articleTypeList = [];
        for (let idArticleType of selectedFilterArticleTypes) {
            let articleType = articleTypes.find(c => c.id == idArticleType);
            if (articleType) {
                articleTypeList.push({
                id: articleType.id,
                name: articleType.name
            });
            }
        }

        let selectedArticleTypes = this.getTemplateViewModel().selectedArticleTypesSummary();

        for (let at of articleTypeList) {
            let existingArticleType = selectedArticleTypes.find(c => c.id == at.id);
            if (!existingArticleType) {
                selectedArticleTypes.push(at);
            }
        }

        for (let i = selectedArticleTypes.length - 1; i >= 0; i--) {
            let articleTypeToRemove = articleTypeList.find(c => c.id == selectedArticleTypes[i].id);
            if (!articleTypeToRemove) {
                selectedArticleTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedArticleTypesSummary([]);
        this.getTemplateViewModel().selectedArticleTypesSummary(selectedArticleTypes);
    }

    protected onClickDeleteSelectedContentType(data) {
        let allContentTypes = this.contentTypesForQuiz.getItems();
        let selectedContentTypes = this.getTemplateViewModel().selectedContentTypes();
        let index = selectedContentTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedContentTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedContentTypes(selectedContentTypes);

        let selectedFilterContentTypes = this.contentTypesForQuiz.getSelectedItems();

        index = selectedFilterContentTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterContentTypes.splice(index, 1);
        }

        let updatedContentTypes = [];
        for (let idCat of selectedFilterContentTypes) {
            let ct = allContentTypes.find(c => c.id == idCat);
            if (ct) {
                updatedContentTypes.push(ct);
            }
        }

        this.contentTypesForQuiz.setSelectedItems(updatedContentTypes);
    }

    protected onClickDeleteSelectedArticleType(data) {
        let allArticleTypes = this.articleTypesForQuiz.getItems();
        let selectedArticleTypes = this.getTemplateViewModel().selectedArticleTypes();
        let index = selectedArticleTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedArticleTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedArticleTypes(selectedArticleTypes);

        let selectedFilterArticleTypes = this.articleTypesForQuiz.getSelectedItems();

        index = selectedFilterArticleTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterArticleTypes.splice(index, 1);
        }

        let updatedArticleTypes = [];
        for (let idType of selectedFilterArticleTypes) {
            let at = allArticleTypes.find(c => c.id == idType);
            if (at) {
                updatedArticleTypes.push(at);
            }
        }

        this.articleTypesForQuiz.setSelectedItems(updatedArticleTypes);
    }

    protected onClickDeleteSelectedArticleTypeFAQ(data) {
        let allArticleTypes = this.articleTypesForFaq.getItems();
        let selectedArticleTypes = this.getTemplateViewModel().selectedfaqArticleTypes();
        let index = selectedArticleTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedArticleTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedfaqArticleTypes(selectedArticleTypes);

        let selectedFilterArticleTypes = this.articleTypesForFaq.getSelectedItems();

        index = selectedFilterArticleTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterArticleTypes.splice(index, 1);
        }

        let updatedArticleTypes = [];
        for (let idType of selectedFilterArticleTypes) {
            let at = allArticleTypes.find(c => c.id == idType);
            if (at) {
                updatedArticleTypes.push(at);
            }
        }

        this.articleTypesForFaq.setSelectedItems(updatedArticleTypes);
    }

    protected onClickDeleteSelectedContentTypeSummary(data) {
        let allContentTypes = this.contentTypesForSummary.getItems();
        let selectedContentTypes = this.getTemplateViewModel().selectedContentTypesSummary();
        let index = selectedContentTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedContentTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedContentTypesSummary(selectedContentTypes);

        let selectedFilterContentTypes = this.contentTypesForSummary.getSelectedItems();

        index = selectedFilterContentTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterContentTypes.splice(index, 1);
        }

        let updatedContentTypes = [];
        for (let idCat of selectedFilterContentTypes) {
            let ct = allContentTypes.find(c => c.id == idCat);
            if (ct) {
                updatedContentTypes.push(ct);
            }
        }

        this.contentTypesForSummary.setSelectedItems(updatedContentTypes);
    }

    protected onClickDeleteSelectedArticleTypeSummary(data) {
        let allArticleTypes = this.articleTypesForSummary.getItems();
        let selectedArticleTypes = this.getTemplateViewModel().selectedArticleTypesSummary();
        let index = selectedArticleTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedArticleTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedArticleTypesSummary(selectedArticleTypes);

        let selectedFilterArticleTypes = this.articleTypesForSummary.getSelectedItems();

        index = selectedFilterArticleTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterArticleTypes.splice(index, 1);
        }

        let updatedArticleTypes = [];
        for (let idType of selectedFilterArticleTypes) {
            let at = allArticleTypes.find(c => c.id == idType);
            if (at) {
                updatedArticleTypes.push(at);
            }
        }

        this.articleTypesForSummary.setSelectedItems(updatedArticleTypes);
    }

    protected onClickDeleteSelectedContentTypeFAQ(data){

        let allContentTypes = this.contentTypesForFaq.getItems();
        let selectedContentTypes = this.getTemplateViewModel().selectedfaqContentTypes();
        let index = selectedContentTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedContentTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedfaqContentTypes(selectedContentTypes);

        let selectedFilterContentTypes = this.contentTypesForFaq.getSelectedItems();

        index = selectedFilterContentTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterContentTypes.splice(index, 1);
        }

        let updatedContentTypes = [];
        for (let idCat of selectedFilterContentTypes) {
            let ct = allContentTypes.find(c => c.id == idCat);
            if (ct) {
                updatedContentTypes.push(ct);
            }
        }

        this.contentTypesForFaq.setSelectedItems(updatedContentTypes);
    }

    
    protected getTemplateName(): string {
        return "config_ai_template";
    }

    public setPermissions(permissions) {
        this.getTemplateViewModel().permissions(permissions);
        this.getTemplateViewModel().activeTab((permissions['config_assistant_general'] && permissions['config_assistant_general'].write) ? 'general' : (permissions['config_assistant_website'] && permissions['config_assistant_website'].write) ? 'website' : 'emaki');
    }

    public getAiSettings() {
        let raw = {
            simpleSummaryPersonality: this.getTemplateViewModel().simpleSummaryPersonality(),
            factualSummaryPersonality: this.getTemplateViewModel().factualSummaryPersonality(),
            satiricalSummaryPersonality: this.getTemplateViewModel().satiricalSummaryPersonality(),
            brandContext: this.getTemplateViewModel().brandContext(),
            emakiBrandContext: this.getTemplateViewModel().emakiBrandContext(),
            summaryPrompt: this.getTemplateViewModel().summaryPrompt(),
            articleID: this.getTemplateViewModel().articleID(),
            quizAvailable: this.getTemplateViewModel().quizAvailable(),
            summaryAvailable: this.getTemplateViewModel().summaryAvailable(),
            factualSummaryAvailable: this.getTemplateViewModel().factualSummaryAvailable(),
            satiricalSummaryAvailable: this.getTemplateViewModel().satiricalSummaryAvailable(),
            simpleSummaryAvailable: this.getTemplateViewModel().simpleSummaryAvailable(),
            quizPrompt: this.getTemplateViewModel().quizPrompt(),
            quizBrandContext: this.getTemplateViewModel().quizBrandContext(),
            quizPersonality: this.getTemplateViewModel().quizPersonality(),
            selectedContentTypes: this.getTemplateViewModel().selectedContentTypes(),
            selectedArticleTypes: this.getTemplateViewModel().selectedArticleTypes(),
            selectedContentTypesSummary: this.getTemplateViewModel().selectedContentTypesSummary(),
            selectedArticleTypesSummary: this.getTemplateViewModel().selectedArticleTypesSummary(),
            titleDiscoverandOptimizePrompt: this.getTemplateViewModel().titleDiscoverandOptimizePrompt(),
            seoSuggestionPromptAvailable: this.getTemplateViewModel().seoSuggestionPromptAvailable(),
            seoSuggestionPrompt: this.getTemplateViewModel().seoSuggestionPrompt(),
            socialmediaSuggestionPromptAvailable: this.getTemplateViewModel().socialmediaSuggestionPromptAvailable(),
            socialmediaSuggestionPrompt: this.getTemplateViewModel().socialmediaSuggestionPrompt(),
            threadSuggestionPromptAvailable: this.getTemplateViewModel().threadSuggestionPromptAvailable(),
            threadSuggestionPrompt: this.getTemplateViewModel().threadSuggestionPrompt(),
            excerptSuggestionPromptAvailable: this.getTemplateViewModel().excerptSuggestionPromptAvailable(),
            //FAQ
            selectedfaqContentTypes: this.getTemplateViewModel().selectedfaqContentTypes(),
            faqPrompt: this.getTemplateViewModel().faqPrompt(),
            selectedfaqArticleTypes: this.getTemplateViewModel().selectedfaqArticleTypes(),
            faqAvailable: this.getTemplateViewModel().faqAvailable(),
            faqPersonality: this.getTemplateViewModel().faqPersonality(),
            titleDiscoverandOptimizePromptAvailable: this.getTemplateViewModel().titleDiscoverandOptimizePromptAvailable(),
            excerptSuggestionPrompt: this.getTemplateViewModel().excerptSuggestionPrompt()
        }


        let subViewModel = {
                simpleSummaryPersonality: raw.simpleSummaryPersonality,
                factualSummaryPersonality: raw.factualSummaryPersonality,
                satiricalSummaryPersonality: raw.satiricalSummaryPersonality,
                brandContext: raw.brandContext,
                emakiBrandContext: raw.emakiBrandContext,
                summaryPrompt: raw.summaryPrompt,
                articleID: raw.articleID,
                quizAvailable: raw.quizAvailable,
                summaryAvailable: raw.summaryAvailable,
                factualSummaryAvailable: raw.factualSummaryAvailable,
                satiricalSummaryAvailable: raw.satiricalSummaryAvailable,
                simpleSummaryAvailable: raw.simpleSummaryAvailable,
                quizPrompt: raw.quizPrompt,
                quizBrandContext: raw.quizBrandContext,
                quizPersonality: raw.quizPersonality,
                selectedContentTypes: raw.selectedContentTypes,
                selectedArticleTypes: raw.selectedArticleTypes,
                selectedContentTypesSummary: raw.selectedContentTypesSummary,
                selectedArticleTypesSummary: raw.selectedArticleTypesSummary,
                titleDiscoverandOptimizePrompt: raw.titleDiscoverandOptimizePrompt,
                seoSuggestionPromptAvailable: raw.seoSuggestionPromptAvailable,
                seoSuggestionPrompt: raw.seoSuggestionPrompt,
                socialmediaSuggestionPromptAvailable: raw.socialmediaSuggestionPromptAvailable,
                socialmediaSuggestionPrompt: raw.socialmediaSuggestionPrompt,
                threadSuggestionPromptAvailable: raw.threadSuggestionPromptAvailable,
                threadSuggestionPrompt: raw.threadSuggestionPrompt,
                excerptSuggestionPromptAvailable: raw.excerptSuggestionPromptAvailable,
                //FAQ
                selectedfaqContentTypes: raw.selectedfaqContentTypes,
                faqPrompt: raw.faqPrompt,
                selectedfaqArticleTypes: raw.selectedfaqArticleTypes,
                faqAvailable: raw.faqAvailable,
                faqPersonality: raw.faqPersonality,
                titleDiscoverandOptimizePromptAvailable: raw.titleDiscoverandOptimizePromptAvailable,
                excerptSuggestionPrompt: raw.excerptSuggestionPrompt
            };

        return subViewModel;
    }

    protected onClickSaveAiSettings(): any {
        this.caller.saveAiSettings();
    }

    protected onClickCancelAiSettings(): any {
        this.caller.cancelSiteSettings();
    }


    public setAiSettings(data: any) {
        this.initialValues = data;
        this.getTemplateViewModel().simpleSummaryPersonality(data.simpleSummaryPersonality);
        this.getTemplateViewModel().factualSummaryPersonality(data.factualSummaryPersonality);
        this.getTemplateViewModel().satiricalSummaryPersonality(data.satiricalSummaryPersonality);
        this.getTemplateViewModel().brandContext(data.brandContext);
        this.getTemplateViewModel().emakiBrandContext(data.emakiBrandContext);
        this.getTemplateViewModel().summaryPrompt(data.summaryPrompt);
        this.getTemplateViewModel().articleID(data.articleID);
        this.getTemplateViewModel().quizAvailable(data.quizAvailable);
        this.getTemplateViewModel().summaryAvailable(data.summaryAvailable);
        this.getTemplateViewModel().factualSummaryAvailable(data.factualSummaryAvailable);
        this.getTemplateViewModel().satiricalSummaryAvailable(data.satiricalSummaryAvailable);
        this.getTemplateViewModel().simpleSummaryAvailable(data.simpleSummaryAvailable);
        this.getTemplateViewModel().quizPrompt(data.quizPrompt);
        this.getTemplateViewModel().quizBrandContext(data.quizBrandContext);
        this.getTemplateViewModel().titleDiscoverandOptimizePrompt(data.titleDiscoverandOptimizePrompt);
        this.getTemplateViewModel().seoSuggestionPromptAvailable(data.seoSuggestionPromptAvailable);
        this.getTemplateViewModel().seoSuggestionPrompt(data.seoSuggestionPrompt);
        this.getTemplateViewModel().socialmediaSuggestionPromptAvailable(data.socialmediaSuggestionPromptAvailable);
        this.getTemplateViewModel().socialmediaSuggestionPrompt(data.socialmediaSuggestionPrompt);
        this.getTemplateViewModel().threadSuggestionPromptAvailable(data.threadSuggestionPromptAvailable);
        this.getTemplateViewModel().threadSuggestionPrompt(data.threadSuggestionPrompt);
        this.getTemplateViewModel().excerptSuggestionPromptAvailable(data.excerptSuggestionPromptAvailable);
        this.getTemplateViewModel().titleDiscoverandOptimizePromptAvailable(data.titleDiscoverandOptimizePromptAvailable);
        this.getTemplateViewModel().excerptSuggestionPrompt(data.excerptSuggestionPrompt);
        this.getTemplateViewModel().quizPersonality(data.quizPersonality);
        this.getTemplateViewModel().selectedContentTypes(data.selectedContentTypes || []);
        this.contentTypesForQuiz.setSelectedItems(data.selectedContentTypes || []);
        this.getTemplateViewModel().selectedArticleTypes(data.selectedArticleTypes || []);
        this.articleTypesForQuiz.setSelectedItems(data.selectedArticleTypes || []);
        this.getTemplateViewModel().selectedContentTypesSummary(data.selectedContentTypesSummary || []);
        this.contentTypesForSummary.setSelectedItems(data.selectedContentTypesSummary || []);
        this.getTemplateViewModel().selectedArticleTypesSummary(data.selectedArticleTypesSummary || []);
        this.articleTypesForSummary.setSelectedItems(data.selectedArticleTypesSummary || []);
        //FAQ
        this.getTemplateViewModel().selectedfaqContentTypes(data.selectedfaqContentTypes || []);
        this.contentTypesForFaq.setSelectedItems(data.selectedfaqContentTypes || []);
        this.getTemplateViewModel().selectedfaqArticleTypes(data.selectedfaqArticleTypes || []);
        this.articleTypesForFaq.setSelectedItems(data.selectedfaqArticleTypes || []);
        this.getTemplateViewModel().faqAvailable(data.faqAvailable || false);
        this.getTemplateViewModel().faqPersonality(data.faqPersonality || "");
        this.getTemplateViewModel().faqPrompt(data.faqPrompt || "");
    }

    public resetTitleDiscoverandOptimizePrompt(): void {
        this.getTemplateViewModel().titleDiscoverandOptimizePrompt(this.initialValues.titleDiscoverandOptimizePrompt);
    }
       public resetThreadSuggestionPrompt(): void {
        this.getTemplateViewModel().threadSuggestionPrompt(this.initialValues.threadSuggestionPrompt);
    }

    public resetSeoSuggestionPrompt(): void {
        this.getTemplateViewModel().seoSuggestionPrompt(this.initialValues.seoSuggestionPrompt);
    }

    public resetSocialmediaSuggestionPrompt(): void {
        this.getTemplateViewModel().socialmediaSuggestionPrompt(this.initialValues.socialmediaSuggestionPrompt);
    }

    public resetExcerptSuggestionPrompt(): void {
        this.getTemplateViewModel().excerptSuggestionPrompt(this.initialValues.excerptSuggestionPrompt);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/config_ai_template.ts